'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {

    var tagButtonArray = document.querySelectorAll('div[data-tagid]');
    if (tagButtonArray.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(tagButtonArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var tagButton = _step.value;

                tagButton.addEventListener('click', tagButtonClick);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    function tagButtonClick(event) {
        var selectionItems = document.querySelectorAll('div[data-selectiontags]');
        if ([].concat((0, _toConsumableArray3.default)(event.target.classList)).some(function (c) {
            return c === 'selected';
        })) {
            event.target.classList.remove('selected');

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(selectionItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    hideOrShowItem(item, false, 100);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(tagButtonArray), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _tagButton = _step3.value;

                    if (_tagButton !== event.target) {
                        _tagButton.classList.remove('selected');
                    } else {
                        _tagButton.classList.add('selected');
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(selectionItems), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _item = _step4.value;


                    var selectionTags = JSON.parse(_item.dataset.selectiontags);
                    var tagid = parseInt(event.target.dataset.tagid);
                    var hide = selectionTags.indexOf(tagid) < 0;

                    hideOrShowItem(_item, hide);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    }

    function hideOrShowItem(item, hide) {
        var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

        var animationClass = 'hidden-selection-item';
        var absoluteHideCLass = 'hidden';

        if (hide) {
            item.classList.add(animationClass);
            window.setTimeout(function () {
                item.classList.add(absoluteHideCLass);
            }, timeout);
        } else {
            item.classList.remove(absoluteHideCLass);
            window.setTimeout(function () {
                item.classList.remove(animationClass);
            }, timeout);
        }
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/selectedCategories.js
// module id = 1082
// module chunks = 1